// caracteres numeriques ou espace
import { TITRE_MADAME, TITRE_MONSIEUR } from "src/commun/hooks/useTitreOptions";

export const testTelephone = (value: string | null | undefined): boolean => {
  // on ne bloque pas le test s'il n'y a pas de valeur
  if (!value && value !== "") {
    return true;
  }
  const trimmedValue = value.replace(/\s/g, "");

  return /^(0|\+)([()\-0-9])*$/.test(trimmedValue);
};

export const testTitre = (value: string | null | undefined): boolean => {
  if (!value && value !== "") {
    return false;
  }

  return [TITRE_MONSIEUR, TITRE_MADAME].indexOf(value) > -1;
};

export const testBirthdate = (value: Date): boolean => {
  if (!value && value !== "") {
    return false;
  }
  const now = new Date();

  const limiteCentAns = new Date(now);
  limiteCentAns.setFullYear(now.getFullYear() - 100);

  return value.getTime() < now.getTime() && value.getTime() >= limiteCentAns.getTime();
};

export type passwordCriteria = {
  displayLabel: string;
  validator: RegExp;
}

export const regexNumber = /.*[0-9].*/;
export const regexLowerCaseLetter = /.*[a-z].*/;
export const regexUpperCaseLetter = /.*[A-Z].*/;
export const regexLength = /^.{8,}$/;

export const testRegex = (value: string | null | undefined, regex: RegExp): boolean => {
  if (!value && value !== "") {
    return false;
  }

  return regex.test(value);
};

export const testPassword = (value: string | null | undefined): boolean => {
  if (!value && value !== "") {
    return false;
  }

  return regexNumber.test(value) && regexLowerCaseLetter.test(value) && regexUpperCaseLetter.test(value) && regexLength.test(value);
};